import { jsx as _jsx } from "react/jsx-runtime";
const AppCrash = () => {
    return (_jsx("section", { className: "p-5", children: _jsx("h1", { children: "Something went wrong. Please close this window and try again." }) }));
};
export default AppCrash;
